import ProjectMilestoneCoordinationPage from "../../shared/project-milestone-coordination/ProjectMilestoneCoordinationPage";

const ManagementProjectMilestoneCoordinationPage = () => (
  <ProjectMilestoneCoordinationPage source="Management" />
);

export default ManagementProjectMilestoneCoordinationPage;
